module.exports = __webpack_public_path__ + "static/media/app_badge-apple.2c7952a6.svg";